<template>
  <div id="chart-table-box">
    <chart-title leftTitle="MES订单实时监测">
      <el-button
        type="primary"
        slot="detail"
        size="mini"
        style="margin-right: 20px"
        >详 情</el-button
      >
    </chart-title>
    <div id="chart-table">
      <dv-scroll-board
        :config="config"
        style="width: 100%; height: 95%; margin-top: 10px"
      />
    </div>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
export default {
  mixins: [resize],
  name: "center_3",
  components: { ChartTitle },
  data() {
    return {
      config: {
        rowNum: 10,
        headerBGC: "transparent", // 表头背景色
        oddRowBGC: "transparent", // 奇数行背景色
        evenRowBGC: "transparent", // 偶数行背景色
        waitTime: 2000, // 轮播时间间隔(ms)
        align: [
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
        ],
        columnWidth: [50],
        data: [
          [
            `<span style="color:${this.getColor("正常")}">正常</span>`,
            `<span style="color:#409EFF">当前状态</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质类别</span>`,
            `<span style="color:#409EFF">2022-12-19</span>`,
            `<span style="color:#409EFF">距交货 14Day</span>`,
          ],
          [
            `<span style="color:${this.getColor("加急")}">加急</span>`,
            `<span style="color:#409EFF">当前状态</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质类别</span>`,
            `<span style="color:#409EFF">2022-12-19</span>`,
            `<span style="color:#409EFF">距交货 14Day</span>`,
          ],
          [
            `<span style="color:${this.getColor("加急")}">加急</span>`,
            `<span style="color:#409EFF">当前状态</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质类别</span>`,
            `<span style="color:#409EFF">2022-12-19</span>`,
            `<span style="color:#409EFF">距交货 14Day</span>`,
          ],
          [
            `<span style="color:${this.getColor("正常")}">正常</span>`,
            `<span style="color:#409EFF">当前状态</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质类别</span>`,
            `<span style="color:#409EFF">2022-12-19</span>`,
            `<span style="color:#409EFF">距交货 14Day</span>`,
          ],
          [
            `<span style="color:${this.getColor("正常")}">正常</span>`,
            `<span style="color:#409EFF">当前状态</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质类别</span>`,
            `<span style="color:#409EFF">2022-12-19</span>`,
            `<span style="color:#409EFF">距交货 14Day</span>`,
          ],
          [
            `<span style="color:${this.getColor("正常")}">正常</span>`,
            `<span style="color:#409EFF">当前状态</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质类别</span>`,
            `<span style="color:#409EFF">2022-12-19</span>`,
            `<span style="color:#409EFF">距交货 14Day</span>`,
          ],
          [
            `<span style="color:${this.getColor("正常")}">正常</span>`,
            `<span style="color:#409EFF">当前状态</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质类别</span>`,
            `<span style="color:#409EFF">2022-12-19</span>`,
            `<span style="color:#409EFF">距交货 14Day</span>`,
          ],
          [
            `<span style="color:${this.getColor("加急")}">加急</span>`,
            `<span style="color:#409EFF">当前状态</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质类别</span>`,
            `<span style="color:#409EFF">2022-12-19</span>`,
            `<span style="color:#409EFF">距交货 14Day</span>`,
          ],
          [
            `<span style="color:${this.getColor("加急")}">加急</span>`,
            `<span style="color:#409EFF">当前状态</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质类别</span>`,
            `<span style="color:#409EFF">2022-12-19</span>`,
            `<span style="color:#409EFF">距交货 14Day</span>`,
          ],
          [
            `<span style="color:${this.getColor("正常")}">正常</span>`,
            `<span style="color:#409EFF">当前状态</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质类别</span>`,
            `<span style="color:#409EFF">2022-12-19</span>`,
            `<span style="color:#409EFF">距交货 14Day</span>`,
          ],
          [
            `<span style="color:${this.getColor("正常")}">正常</span>`,
            `<span style="color:#409EFF">当前状态</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:#409EFF">地址</span>`,
            `<span style="color:#409EFF">材质类别</span>`,
            `<span style="color:#409EFF">2022-12-19</span>`,
            `<span style="color:#409EFF">距交货 14Day</span>`,
          ],
        ],
      },
    };
  },
  props: {},
  created() {},
  mounted() {},

  methods: {
    getColor(val) {
      if (val == "正常") {
        return "#67C23A";
      } else if (val == "加急") {
        return "#F56C6C";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-table-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 30vh;
  #chart-table {
    height: calc(100% - 30px);
    background: transparent;
    padding: 0 20px;
    .el-table {
      background: transparent;
      tr {
        background: transparent;
      }
    }
  }
}
</style>
<style>
.el-table td,
.el-table th {
  padding: 6px 0;
  color: #ffffff;
  font-size: 12px;
}
.el-table th,
.el-table tr {
  background-color: transparent;
}
.el-table tr:hover {
  background-color: transparent;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: transparent;
  /* color: #f19944; */ /* 设置文字颜色，可以选择不设置 */
}
</style>
